const YOUTUBE_ID_REGEX = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|shorts\/|live\/|watch\?v=|watch\?.+&v=))([a-zA-Z0-9_-]{11})/;
const RUTUBE_ID_REGEX = /(?:rutube\.ru\/video\/|rutube\.ru\/play\/embed\/)([a-zA-Z0-9]+)/;

function getYoutubeId(url) {
  if (typeof url !== 'string') {
    return null;
  }

  const match = url.match(YOUTUBE_ID_REGEX);

  return match ? match[1] : null;
}

function getRutubeId(url) {
  if (typeof url !== 'string') {
    return null;
  }

  const match = url.match(RUTUBE_ID_REGEX);

  return match ? match[1] : null;
}

// react-player@1.x's own YouTube URL matcher only recognizes youtu.be/, embed/, v/, watch?v= —
// it doesn't know about /shorts/ or /live/, and silently falls back to its generic <video> file
// player for those, which then fails with a native "no supported format/MIME type" error.
// Normalizing up front sidesteps that regardless of which path format was pasted.
function getYoutubePlayableUrl(url) {
  const id = getYoutubeId(url);

  return id ? `https://www.youtube.com/watch?v=${id}` : url;
}

// YouTube's own thumbnail CDN — static image serving, no server-side logic. Deliberately NOT using
// react-player's light={true} auto-fetch (which calls the third-party https://noembed.com/embed
// oEmbed proxy client-side): that proxy has been observed returning a bare Perl server error for
// specific, otherwise-perfectly-valid video IDs (consistently reproducible, not a transient/rate-limit
// blip), silently blanking the preview with no way for us to retry or detect it. Supplying the
// thumbnail URL directly sidesteps that dependency entirely.
function getYoutubeThumbnailUrl(url) {
  const id = getYoutubeId(url);

  return id ? `https://i.ytimg.com/vi/${id}/maxresdefault.jpg` : null;
}

export {
  getRutubeId,
  getYoutubeId,
  getYoutubePlayableUrl,
  getYoutubeThumbnailUrl,
};
